import { useEffect } from 'react';
import { ANIMATION_SPEED } from '@config';
import { GameStatus } from '@containers';

const getTranslateX = (el: HTMLElement) => {
  const matrix = getComputedStyle(el).transform;
  const match = matrix.match(/matrix.*\((.+)\)/);
  let position = 0;

  if (match) {
    const matrixValues = match[1].split(', ');
    position = Number(matrixValues[4]);
  }

  return position;
};

export const useMoveItems = (items: any[], speed: number, gameStatus: GameStatus) => {
  useEffect(() => {
    const ids: number[] = [];
    let animationStep = ANIMATION_SPEED[speed - 1] && gameStatus === 'play' ? ANIMATION_SPEED[speed - 1] : 0;

    items.forEach((item) => {
      if (item.ref.current) {
        let position = getTranslateX(item.ref.current);

        const step = () => {
          const id = requestAnimationFrame(step);
          ids.push(id);

          if (items.length > 0 && item.ref.current) {
            item.ref.current.style.transform = `translateX(${position}px)`;
            position = position - animationStep;
          }
        }

        step();
      }
    });

    return () =>  ids.forEach((id) => cancelAnimationFrame(id));
  }, [gameStatus, items, speed]);
}
